import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=4f9220e6&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=4f9220e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_fjgmzwr3s5tq3rnxsqdvyzw3tu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9220e6",
  null
  
)

export default component.exports